module.exports = "https://coursera_assets.s3.amazonaws.com/images/1f66c35fa441b49d64726909b8274309.png";